import React from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import Title from '../../../../components/Form/Items/Title'
import FieldSelector from './Form/FieldSelector'

const DEFAULT_DATA = () => ({
  title: i18n.t('processes.process_settings.wizard.tasks.types.contract_data.form.defaults.title', {
    emoji: '\u{1F4DD}',
  }),
  description: `${i18n.t(
    'processes.process_settings.wizard.tasks.types.contract_data.form.defaults.descriptions.1'
  )}<p><span><strong>${i18n.t(
    'processes.process_settings.wizard.tasks.types.contract_data.form.defaults.descriptions.2',
    { emoji: '\u{1F4C4}' }
  )}</strong></span>${i18n.t(
    'processes.process_settings.wizard.tasks.types.contract_data.form.defaults.descriptions.3'
  )}`,
})

const Content = () => {
  const { associatedTaskItem: item, form, initializeForm } = useFormProvider()
  const defaultData = DEFAULT_DATA()

  useEffect(() => {
    initializeForm(DataCollectionCategories.contract_data, {
      task_type: TaskConfigurationTypes.DataCollection,
      title: item ? item.title : defaultData.title,
      instruction: item ? item.instruction : defaultData.description,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees excludeAffectedUser />,
        fieldSelector: <FieldSelector />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
